import { TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import React from 'react';
import Coluna from './Coluna';
import { useLocalStorage } from '../../helper';

type Props = {
  colunas: Coluna<any>[];
  mostrarColunas: boolean[];
  hide: boolean;
  chave: string;
};

type PropsColumnHead = {
  coluna: Coluna<any>;
  mostrarColuna: boolean;
  chave: string;
};

const ColumnHead: React.FC<PropsColumnHead> = (props) => {
  const { coluna, mostrarColuna, chave } = props;

  const [direction, setDirection] = useLocalStorage<'desc' | 'asc'>(
    `@EdTableHead/${chave}`,
    'desc'
  );

  if (!mostrarColuna) {
    return null;
  }

  if (coluna.onSort) {
    return (
      <TableCell sortDirection={direction} align={coluna.align}>
        <TableSortLabel
          active={true}
          direction={direction}
          onClick={() => {
            const newDirection = direction === 'desc' ? 'asc' : 'desc';
            setDirection(newDirection);
            if (coluna.onSort) {
              coluna.onSort(coluna, newDirection);
            }
          }}
        >
          {coluna.label}
        </TableSortLabel>
      </TableCell>
    );
  }

  return (
    <TableCell align={coluna.align} padding={'normal'} sx={{ whiteSpace: 'nowrap' }}>
      {coluna.label}
    </TableCell>
  );
};

const EdTableHead: React.FC<Props> = (props) => {
  const { colunas, mostrarColunas, hide, chave } = props;

  if (hide) {
    return null;
  }

  return (
    <TableHead>
      <TableRow>
        {colunas.map((coluna, i) => (
          <ColumnHead
            key={'header' + i}
            coluna={coluna}
            mostrarColuna={mostrarColunas[i]}
            chave={chave}
          />
        ))}
      </TableRow>
    </TableHead>
  );
};

export default EdTableHead;
